import { render, staticRenderFns } from "./realtime_data.vue?vue&type=template&id=1910fe62&"
import script from "./realtime_data.vue?vue&type=script&lang=js&"
export * from "./realtime_data.vue?vue&type=script&lang=js&"
import style0 from "./realtime_data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports